import { InfoCircleOutlined } from '@ant-design/icons';
import React, { memo } from 'react';
import { Col, CountrySelect, Form, FormModal, Input, Row, Select, Tooltip } from 'components';
import { zipCodeRegex } from 'utils/helpers';
import { useAddressUpdate } from './useAddressUpdate';

const { Item } = Form;

export interface IAddressUpdate {
  modalState: boolean;
  onModalStateChange: () => void;
  dataToEdit: Record<string, any>;
}

export const AddressEdit = memo<IAddressUpdate>((props) => {
  const { onModalStateChange, modalState, dataToEdit } = props;
  const { onFinish, contextHolder, isLoading, form, states, handleCountryChange, onCancel } = useAddressUpdate({
    onModalStateChange,
    modalState,
    dataToEdit,
  });
  return (
    <>
      {contextHolder}
      <FormModal
        form={form}
        title={'Update Corporate Address'}
        okText={'Save'}
        open={modalState}
        isLoading={isLoading}
        onSubmit={onFinish}
        onCancel={onCancel}
        autoComplete="off"
      >
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Item name={'country'} label={'Country'}>
              <CountrySelect size={'large'} onSelect={handleCountryChange} />
            </Item>
          </Col>
          {!!states.length && (
            <Col span={12}>
              <Item name={'state'} label={'State'}>
                <Select
                  options={states}
                  size={'large'}
                  showSearch
                  filterOption={(input, option: any) =>
                    option?.label?.toString().toLowerCase().includes(input.toLowerCase()) ?? false
                  }
                />
              </Item>
            </Col>
          )}
          <Col span={12}>
            <Item name={'city'} label={'City'}>
              <Input size={'large'} />
            </Item>
          </Col>
          <Col span={12}>
            <Item name={'streetAddress'} label={'Street Address'}>
              <Input size={'large'} />
            </Item>
          </Col>
          <Col span={12}>
            <Item
              name={'zip'}
              label={'Zip Code'}
              rules={[
                {
                  pattern: zipCodeRegex,
                  message: 'Enter a valid ZIP/Postal Code',
                },
              ]}
            >
              <Input
                suffix={
                  <Tooltip title="Standard formats: 12345, 12345-6789, A1A 1A1, SW1A 1AA, 1234 AB, C1000W1A, 01000-000, 123-4567, 100000.">
                    <InfoCircleOutlined style={{ color: '#05796B' }} />
                  </Tooltip>
                }
                size={'large'}
              />
            </Item>
          </Col>
        </Row>
      </FormModal>
    </>
  );
});
